/* =============================================================
 * import
 * ========================================================== */
import {gsap} from "gsap";
import {scrollResetPosition} from "../../modules/scrollResetPosition";
// const tl = gsap.timeline();


/* =============================================================
 * functions
 * ========================================================== */
export const fade = {
  leave(data, duration = 1000) {
    const ms = duration / 1000;
    return new Promise(resolve => {
      gsap.to(data.current.container, {
        duration: ms,
        opacity: 0,
        ease: "fade",
        onComplete: resolve, // アニメーション完了時にPromiseを解決（≒アニメーション完了を待つ）
      });
    });
  },

  enter(data, duration = 1000) {
    const ms = duration / 1000;
    // data-scroll-hashを使って特定のスクロール位置にページ遷移させる場合、カクツキが生じる場合があります。
    // afterフック内のresetSmoothScrollSmoother関数で極力生じ内容調整をしていますが、万が一生じる場合は、delayなどで調整をしてください。
    gsap.set(data.current.container, {
      opacity: 0,
      position: 'fixed', // アニメーション時の一ずれ防止＆アニメーション後のスクロール位置のずれ防止（特にスマホ時）
    }); // leaveアニメーション後に再表示される現象を回避
    return new Promise (resolve => {
      scrollResetPosition(data); // スクロール位置を適切な位置にセット
      gsap.from(data.next.container, {
        opacity: 0,
        duration: ms,
        ease: "fade",
        // delay: 0,
        onComplete: resolve, // アニメーション完了時にPromiseを解決（≒アニメーション完了を待つ）
      });
    });
  },

};

